<template>
  <section class="d-flex align-items-center justify-content-between">
    <p class="d-flex mr-2"> {{ description }}</p>

    <div class="buttons d-inherit">
        <button class="button" :class="{'is-danger': !value, 'is-light': value, 'is-loading': loading && value}" @click="saveValue(false)">OFF</button>
        <button class="button" :class="{'is-success': value, 'is-light': !value, 'is-loading': loading && !value}" @click="saveValue(true)">ON</button>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'EmailSettingField',
    data () {
      return {
        loading: false,
      }
    },
    props: {
      description: {
        type: String,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
      save: {
        type: Function,
        required: true,
      }
    },
    computed: {
    },
    methods: {
      saveValue (value) {
        this.loading = true
        this.save(value)
        .then(() => {
          this.loading = false
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// EmailSettingField.vue?a31b46ae